import { CommonModule, isPlatformBrowser } from '@angular/common';
import { RouterOutlet } from '@angular/router';

import { MatDialogModule } from '@angular/material/dialog';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatMenuModule } from '@angular/material/menu';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { Component, Input, Output, EventEmitter, ViewChild, ElementRef, AfterViewInit, OnInit, OnChanges, PLATFORM_ID, Inject, HostListener, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';

import { AnalysisServiceService } from '../../services/analysis-service/analysis-service.service';
import { BlockedModalComponent } from '../../tools/blocked-modal/blocked-modal.component';

import { HttpClientModule } from '@angular/common/http';
import { FacadeService } from '../../services/facade.service';
import { HttpClient } from "@angular/common/http";
import { ProyectosService } from '../../services/proyectos.service';

import { BlockedModal2Component } from '../../tools/blocked-modal2/blocked-modal2.component';


@Component({
  selector: 'text-box-free',
  standalone: true,
  imports: [MatDialogModule,
    CommonModule,
    RouterOutlet,
    MatSidenavModule,
    MatExpansionModule,
    MatToolbarModule,
    MatIconModule,
    MatListModule,
    MatCardModule,
    MatButtonModule,
    MatInputModule,
    MatSelectModule,
    MatCheckboxModule,
    MatMenuModule,
    MatSlideToggleModule,
    FormsModule,
    HttpClientModule],
  templateUrl: './text-box-free.component.html',
  styleUrl: './text-box-free.component.css'
})
export class TextBoxFreeComponent implements AfterViewInit, OnInit, OnChanges {
  @Input() isLogin: boolean;

  InfolimitWords: boolean = false;

  isEyeEditing = false;

  buttonText: string = 'Copy Text';
  buttonImage: string = './assets/images/copy-text-icon.svg';
  buttonTextColor: string = '#EEA21A'; // Color inicial

  currentAnalysisMode: string;
  currentTargetCEFR: string;

  message: boolean = false;

  showAdvanced: boolean;

  loaderDocuments: boolean;

  limitOfDocuments: boolean = false;

  title = 'Project Name or ID';
  isEditing = false;

  firstClick: boolean = true;

  isTooltipModalOpen = false;

  textAreaContent = 'Welcome to Text Inspector! To start, please replace this text here with the text you wish to inspect. You can either copy and paste your text here or import your text from a .txt or .doc file.\n \nAs you add text here, result will be shown on the right. ➔';
  @Input() disabled: boolean = true;
  @Input() textInputDisabled: boolean = false;
  @Input() checked: boolean = true;

  @Output() checkedChange = new EventEmitter<boolean>();

  @ViewChild('check', { read: ElementRef }) slide: ElementRef | undefined;
  @ViewChild('fileInput', { static: false }) fileInput!: ElementRef;
  @ViewChild('textArea', { static: false }) textArea!: ElementRef;

  view_button: boolean = true;

  isScreenLarge: boolean = false;


  @ViewChild('scrollContainer') scrollContainer!: ElementRef;

  private isDragging = false;
  private startX = 0;
  private scrollLeft = 0;

  startDrag(event: MouseEvent): void {
    this.isDragging = true;
    this.startX = event.pageX - this.scrollContainer.nativeElement.offsetLeft;
    this.scrollLeft = this.scrollContainer.nativeElement.scrollLeft;
  }

  onDrag(event: MouseEvent): void {
    if (!this.isDragging) return;
    event.preventDefault();
    const x = event.pageX - this.scrollContainer.nativeElement.offsetLeft;
    const walk = (x - this.startX) * 1; // velocidad de arrastre
    this.scrollContainer.nativeElement.scrollLeft = this.scrollLeft - walk;
  }

  onWheel(event: WheelEvent): void {
    const container = this.scrollContainer.nativeElement;
    // Solo si hay scroll horizontal disponible
    if (container.scrollWidth > container.clientWidth) {
      event.preventDefault(); // evita scroll vertical
      container.scrollLeft += event.deltaY; // redirige al eje X
    }
  }

  stopDrag(): void {
    this.isDragging = false;
  }

  checkIcon = 'M19.69,5.23L8.96,15.96l-4.23-4.23L2.96,13.5l6,6L21.46,7L19.69,5.23z';
  ngAfterViewInit(): void {

    if (this.slide) {
      const offIcon = this.slide.nativeElement.querySelector('.mdc-switch__icon--off path');

      if (offIcon) {
        offIcon.setAttribute('d', this.checkIcon);
      }

    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['textInputDisabled']?.currentValue && this.textArea?.nativeElement) {
      this.textArea.nativeElement.blur();
    }
    this.adjustTextareaHeight();
  }

  toggleChecked() {
    this.checkedChange.emit(this.checked);
    this.analysisService.limpiarMarcado();

    const offIcon = this.slide.nativeElement.querySelector('.mdc-switch__icon--off path');
    const onIcon = this.slide.nativeElement.querySelector('.mdc-switch__icon--on path');
    if (offIcon) {
      offIcon.setAttribute('d', this.checkIcon);
    }
    if (onIcon) {
      onIcon.setAttribute('d', this.checkIcon);
    }


  }

  toggleCopyState() {
    const textArea = this.textArea.nativeElement;
    textArea.select();
    document.execCommand('copy');

    this.buttonText = 'Text Copied';
    this.buttonImage = './assets/images/black_icons/copied-text-icon.svg';
    this.buttonTextColor = '#2A3654'; // Color negro de Texto copiado

    setTimeout(() => {
      this.buttonText = 'Copy Text';
      this.buttonImage = './assets/images/copy-text-icon.svg';
      this.buttonTextColor = '#EEA21A'; // Color amarillo para copiar texto
    }, 2000); // 2 segundos
  }

  editTitle() {
    this.isEditing = true;
  }

  saveTitle() {
    this.isEditing = false;
  }

  onKeyPress(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      this.saveTitle();
    }
  }

  constructor(private http: HttpClient, public proyectoService: ProyectosService, @Inject(PLATFORM_ID) private platformId: Object, private analysisService: AnalysisServiceService, private dialog: MatDialog, public fachada: FacadeService,) { }

  openTooltipModal(event: MouseEvent): void {
    if (!this.isTooltipModalOpen) {
      this.isTooltipModalOpen = true;

      const dialogConfig = new MatDialogConfig();
      dialogConfig.position = {
        top: `${event.clientY - 30}px`,
        left: `${event.clientX + 20}px`
      };
      dialogConfig.width = '180px';
      dialogConfig.height = '96px';
      dialogConfig.hasBackdrop = false;
      dialogConfig.autoFocus = false;

      const dialogRef = this.dialog.open(BlockedModal2Component, dialogConfig);

      dialogRef.afterClosed().subscribe(() => {
        this.isTooltipModalOpen = false;
      });
    }
  }

  closeTooltipModal(): void {
    setTimeout(() => {
      this.dialog.closeAll();
    }, 1000);
  }

  openTooltipModalMobile(event: MouseEvent): void {
    if (!this.isTooltipModalOpen) {
      this.isTooltipModalOpen = true;

      const dialogConfig = new MatDialogConfig();
      dialogConfig.position = {
        top: `${event.clientY - 30}px`,
        left: `${event.clientX - 200}px`
      };
      dialogConfig.width = '180px';
      dialogConfig.height = '95px';
      dialogConfig.hasBackdrop = false;
      dialogConfig.autoFocus = false;

      const dialogRef = this.dialog.open(BlockedModal2Component, dialogConfig);

      dialogRef.afterClosed().subscribe(() => {
        this.isTooltipModalOpen = false;
      });


      setTimeout(() => { this.dialog.closeAll(); }, 2000);
    }
  }
  project_data: any;

  initSubscribe() {
    //Subscribimos al servicio para escuchar los datos
    this.proyectoService.proyecto$.subscribe(({ proyecto, firstProject }) => {
      this.project_data = proyecto;
      this.analysisService.changeEnglishType(this.project_data.config_json.englishType)
      this.analysisService.changeAnalysisMode(this.project_data.config_json.textmode)
      this.analysisService.changeTargetCEFR(this.project_data.config_json.target)
      this.analysisService.changeSplitCharacter(this.project_data.config_json.delimiter)
      this.initTextbox();
    });

    // Suscribimos al evento de proyecto guardado
    this.proyectoService.proyectoGuardado$.subscribe(() => {
      setTimeout(() => {
        if (sessionStorage.getItem("id_project")) {
          this.getNameProject();
        }
      }, 2000);  // 5000 ms = 5 segundos

      this.showAdvancedMode();
    });

    this.proyectoService.refrescarL$.subscribe(() => {
      this.initTextbox()
    });
  }

  showAdvancedMode() {
    if (sessionStorage.getItem("id_project")) {
      this.showAdvanced = true;
    }
    else {
      this.showAdvanced = false;
    }
  }

  async initTextbox() {
    // this.proyectoService.proyecto$.subscribe(({ proyecto, firstProject })=>{
    //   this.text_data = updatedata;

    // });
    const rawData = sessionStorage.getItem("analysis_op");


    if (!this.InfolimitWords && !rawData) {
      try {
        await this.proyectoService.loadProjectIdFromSessionStorage()
        let response = this.proyectoService.getdata()
        // let response = await this.fachada.getInfoProyect(this.http,1,"")
        this.text_data = response;
        this.textAreaContent = this.text_data.text
        this.adjustTextareaHeightWithContent();
        if (this.text_data.name == null || this.text_data.name === "Document 1") {
          this.title = this.text_data.text_UID
        }
        // console.log(response);
        this.limitWords();
      } catch (error) {
        console.log(error)
        console.log("No se puede recuperar el proyecto")
      }

    } else {
      this.InfolimitWords = false;
      this.proyectoService.updateBanderaLimpiarTexto(false)



      if (rawData) {
        try {
          const parsedData = JSON.parse(rawData);


          let textArea = document.getElementById("textArea") as HTMLTextAreaElement;
          textArea.value = parsedData.text;
          this.textAreaContent = parsedData.text;
          this.adjustTextareaHeightWithContent();
        } catch (error) {
          console.error(error);
        }
      }

    }
  }

  adjustTextareaHeightWithContent() {
    setTimeout(() => {
      const textArea = document.getElementById("textArea") as HTMLTextAreaElement;
      if (textArea) {
        textArea.style.height = "auto";
        textArea.style.height = textArea.scrollHeight + "px";
      }
    }, 0);
  }
  achiveCEFR: string = "C2";
  ngOnInit(): void {
    this.checked = true;
    this.disabled = true;

    this.adjust();
    if (isPlatformBrowser(this.platformId)) {
      this.isScreenLarge = window.innerWidth > 1000;
      window.addEventListener('resize', this.onResize.bind(this));
    }

    this.proyectoService.limitOfDocuments$.subscribe(state => {
      this.limitOfDocuments = state;
    });

    this.checkLimitWords()
    this.initSubscribe()
    this.initTextbox()
    this.showMessage()
    this.cleanClick()
    setTimeout(() => {
      this.showAdvancedMode();
    }, 1250);

    this.proyectoService.showEditEye$.subscribe(state => {
      this.isEyeEditing = state
    })

    this.analysisService.currentAnalysisMode.subscribe(mode => {
      this.currentAnalysisMode = mode;
    });

    this.analysisService.currentAchiveCEFR.subscribe(mode => {
      this.achiveCEFR = mode;
    });

    this.analysisService.currentTargetCEFR.subscribe(mode => {
      this.currentTargetCEFR = mode;
    });
    this.proyectoService.tabChanged$.subscribe(() => {
      this.initTextbox();
    });
    this.proyectoService.valueCopyButton$.subscribe(state => {
      this.view_button = state;
    });

    this.proyectoService.refreshTextBox$.subscribe(() => {
      this.checked = true;
      this.showAdvancedMode();
    });

  }

  @HostListener('window:resize', ['$event'])
  adjust() {
    this.adjustTextareaHeightWithContent();
  }

  clearText(event: Event) {
    if (!sessionStorage.getItem("id_project")) {
      if (this.firstClick) {
        this.text_data.text = "";
        this.firstClick = false;
      }
    } else {
      this.firstClick = true;
    }
  }

  cleanClick() {
    this.firstClick = true;
  }


  onResize() {
    this.isScreenLarge = window.innerWidth > 1000;
  }

  onFileSelected(event: any) {
    const file: File = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        const content = e.target.result;
        // Crear un archivo temporal
        const blob = new Blob([content], { type: 'text/plain' });
        const url = URL.createObjectURL(blob);

        // Leer el archivo temporal
        fetch(url)
          .then(response => response.text())
          .then(text => {
            // Procesar el texto para eliminar caracteres no deseados
            const textContent = text.replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑ\s]/g, '');

            // Limitar las palabras del archivo cargado
            const words = textContent.split(/\s+/);
            if (words.length > 250) {
              this.InfolimitWords = true;
              this.proyectoService.updateDisablelimitOfWords(true);
            } else {
              this.text_data.text = textContent;
              this.textAreaContent = textContent;
              this.InfolimitWords = false;
              this.resetTimer();
            }

            // Ajustar el tamaño del textarea después de actualizar el contenido
            setTimeout(() => this.adjustTextareaHeightWithContent(), 0);
            this.firstClick = false;

            // Eliminar el archivo temporal
            URL.revokeObjectURL(url);
          });
      };
      reader.readAsText(file);
    }
  }

  importText() {
    this.fileInput.nativeElement.click();
  }

  putTextSimple() {
    this.text_data.text = "It's always the quiet ones. Over the past few weeks, Channel 4's unsuspecting Sunday-night schedule has been the place to find the most charmingly revolutionary programme around. A beacon of clay-covered representation that's head and shoulders above the likes of Love Island's amorphous churn of pretty little things, The Great Pottery Throw Down is flying in the face of gender norms while its contestants make seemingly innocuous garden gnomes, candlesticks and children's crockery sets. I am obsessed. \nThe show debuted in 2015 but was cancelled by the BBC in 2018. Since 2020 Channel 4 have been in charge, elevating it far above your average crafts comp by imbuing it with a low-key progressive agenda that the likes of The Great Interior Design Challenge, The Great British Sewing Bee and The Big Flower Fight lack. Much has already been said about the show's potter-in-chief, Keith Brymer Jones. A sturdy but affable bloke who looks like he spends his weekend fronting an oil band or sinking pints with Suggs, Brymer Jones also has a tendency to burst into tears at the sight of a carefully turned vase. But it isn't simply the vision of a grown man letting it all hang out emotionally that makes The Great Pottery Throw Down such radical viewing. Rather, it's one of the few reality shows that gives the vast majority of its screentime to women over the age of 50.";
    setTimeout(() => this.adjustTextareaHeightWithContent(), 0);
    this.resetTimer();
    this.firstClick = false;
  }

  sorted_related_projects: any[] = [];

  async getNameProject() {
    let id_project = sessionStorage.getItem("id_project");

    try {

      this.loaderDocuments = true;
      let response = await this.fachada.getInfoProyect(this.http, id_project);

      this.text_data = response;

      // Nueva propiedad solo para mostrar en el front

      if (this.text_data.related_projects && Array.isArray(this.text_data.related_projects)) {
        // Normalizar + ordenar
        this.sorted_related_projects = this.text_data.related_projects
          .map(p => ({
            ...p,
            active: p.active === true || p.active === "true" ? "true" : "false"
          }))
          .sort((a, b) => a.id_project - b.id_project);
      } else {
        this.sorted_related_projects = [];
      }




      // ⚡️ Si solo hay 1, ocultamos la lista
      if (this.text_data.related_projects.length <= 1) {
        this.text_data.related_projects = [];
      }

      // Definir el título
      if (!this.text_data.name || this.text_data.name.trim() === "" || this.text_data.name === "Document 1") {
        this.title = this.text_data.text_UID;
      } else {
        this.title = this.text_data.name;
      }

      this.loaderDocuments = false;
    } catch (error) {
      console.error("No se obtuvo el nombre", error);
      this.getNameProject();
    }
  }

  async loadRelatedProject(project: any) {
    try {
      await this.proyectoService.getinfo(this.http, project.id_project);



      window.location.reload();
    } catch (error) {
      console.error("Error al cargar proyecto relacionado", error);
    }
  }

  // Función para limitar las palabras a 250 en tiempo real
  limitWords(event: any = null): void {
    let content = this.textAreaContent;
    if (event) {
      content = event.target.value;
    }
    const words = content.split(/\s+/).filter(w => w.length > 0);;
    const isLessThan100Words = words.length < 100;
    this.proyectoService.updateWordCountStatus(isLessThan100Words); // Actualiza el estado en el servicio

    const wasOverLimit = this.InfolimitWords;


    if (words.length > 250) {
      this.InfolimitWords = true;
    } else {
      this.textAreaContent = content;
      this.InfolimitWords = false;
    }

    if (wasOverLimit) {
      this.resetTimer(); // <-- esto reinicia el análisis
    }

  }

  checkLimitWords(): void {
    let content = this.textAreaContent;
    const words = content.split(/\s+/).filter(w => w.length > 0);;
    const isLessThan100Words = words.length < 100;
    this.proyectoService.updateWordCountStatus(isLessThan100Words); // Actualiza el estado en el servicio


    if (words.length > 250) {
      this.InfolimitWords = true;
    } else {
      this.textAreaContent = content;
      this.InfolimitWords = false;
    }

  }

  showModal = false;

  onMouseEnter() {
    if (this.disabled == true) {
      this.showModal = true;
    }
  }

  onMouseLeave() {
    this.showModal = false;
  }

  closeModal() {
    this.showModal = false;
  }

  showModalMobile = false;

  onTabClickMobile() {
    if (this.disabled == true) {
      this.showModalMobile = true;
      setTimeout(() => {
        this.showModalMobile = false;
      }, 3000); // Desaparece después de 2 segundos
    }
  }

  private startTimer() {
    if (!this.InfolimitWords) {
      this.inactivityTimer = setTimeout(() => {
        this.onInactivity();  // Llama a la función después de 1.2 segundos de inactividad
        this.proyectoService.updateloader(false);
        this.proyectoService.updateloaderAnalyzing(true);
        this.proyectoService.verifyLoaderAnalyzing(true);
      }, 1200);  // 1200 ms = 1.2 segundos
    }
  }

  private async onInactivity() {
    if (!this.InfolimitWords) {
      try {
        if (sessionStorage.getItem("id_project") && this.text_data.text.trim() !== "") {
          let response = await this.fachada.UpdateTextofProyect(this.http, this.text_data)
          this.text_data = response;
          this.proyectoService.updateData(this.text_data)
          this.textAreaContent = this.text_data.text
          if (this.text_data.name == null || this.text_data.name === "Document 1") {
            this.title = this.text_data.text_UID
          }
        } else {

          this.proyectoService.createValue.next(true)

        }
      } catch (error) {
        console.log(error)
        console.log("No se puede recuperar el proyecto")
      } finally {
        this.proyectoService.verifyLoaderAnalyzing(false);
        setTimeout(() => {
          this.proyectoService.updateloaderAnalyzing(false);
        }, 500);
      }
    } else {
      this.proyectoService.updateloader(false);
      this.proyectoService.updateDisablelimitOfWords(true);
      this.proyectoService.verifyLoaderAnalyzing(false);
          setTimeout(() => {
            this.proyectoService.updateloaderAnalyzing(false);
    }, 500); 
    }
  }

  private inactivityTimer: any;
  public text_data;


  resetTimer() {
    if (!this.InfolimitWords) {
      clearTimeout(this.inactivityTimer);  // Limpia el temporizador existente
      if (sessionStorage.getItem("id_project") && this.text_data.text.trim() !== "") {
        this.proyectoService.updateloader(true);
      } else {
        this.proyectoService.updateloader(false);
      }
      this.startTimer();                   // Reinicia el temporizador
    } else {
      this.proyectoService.updateloader(false);
    }
  }

  showMessage() {
    setTimeout(() => {
      if (sessionStorage.getItem("id_project")) {
        this.message = true;
      }
      else {
        this.message = false;
      }
    }, 1250);
  }

  adjustTextareaHeight() {
    if (this.textArea && this.textArea.nativeElement) {
      const textarea = this.textArea.nativeElement;
      textarea.style.height = 'auto';
      textarea.style.height = `${textarea.scrollHeight}px`;
    }
  }

  saveEdit() {
    this.proyectoService.updateloaderAnalyzing(true);
    this.proyectoService.verifyLoaderAnalyzing(true);
    this.proyectoService.updateEditEye(true);
    this.proyectoService.terminarEdicionErrores(this.http);
    this.proyectoService.showEditEye(false);
  }
}
